import { ClassName, Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { SignOffQuestionResponseType } from './CreateDailySignOffQuestionForm';
import SignOffQuestionResponseSelect from './SignOffQuestionResponseSelect';

export interface ISignOffQuestionResponseFormFieldProps {
  className?: ClassName;
  form: any;
  name: string;
  onChange?: (value: string) => void;
  validations?: any;
}

const SignOffQuestionResponseFormField = (props: ISignOffQuestionResponseFormFieldProps) => {
  const { form, name, validations, className, onChange, ...other } = props;

  const classes = classNames('sign-in-question-response-form-field', className);

  function renderField({ ...fieldProps }) {
    function handleOnSelect(val: string) {
      fieldProps.handleChange(val, onChange);
    }

    const formValue = form.state.data[name];
    const value = formValue ? formValue : SignOffQuestionResponseType.NO_ACTION;

    return (
      <>
        <SignOffQuestionResponseSelect error={fieldProps.hasError} value={value} onChange={handleOnSelect} {...other} />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
};

export default SignOffQuestionResponseFormField;
